import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import React from 'react';
import styled from 'styled-components';
var Inner = styled.div.withConfig({
  displayName: "Sparkline__Inner",
  componentId: "sc-avhl35-0"
})(["min-width:1px;"]);
export var Sparkline = function Sparkline(_ref) {
  var data = _ref.data,
    _ref$positive = _ref.positive,
    positive = _ref$positive === void 0 ? 'rgba(162,231,197)' : _ref$positive,
    _ref$negative = _ref.negative,
    negative = _ref$negative === void 0 ? 'rgba(252,176,177)' : _ref$negative,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 80 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 24 : _ref$height;
  var rates = data.slice(1).map(function (value, i) {
    return (value / data[i] - 1) * 100;
  });
  var minY = rates.reduce(function (min, point) {
    return point < min ? point : min;
  });
  var maxY = rates.reduce(function (max, point) {
    return point > max ? point : max;
  });
  minY = minY > 0 ? 0 : minY;
  maxY = maxY < 0 ? 0 : maxY;
  var barWidth = (width - 22) / rates.length;
  var extension = maxY - minY;
  var zero = maxY / extension * height;
  return React.createElement(Inner, null, React.createElement("svg", {
    viewBox: "0 0 ".concat(width, " ").concat(height),
    preserveAspectRatio: "none"
  }, rates.map(function (rate, i) {
    return React.createElement("rect", {
      key: i,
      x: i * (Number(barWidth) + 2),
      y: rate > 0 ? (maxY - rate) / extension * height : zero,
      width: Number(barWidth),
      height: rate > 0 ? zero - (maxY - rate) / extension * height : (maxY - rate) / extension * height - zero,
      stroke: rate > 0 ? positive : negative,
      fill: rate > 0 ? positive : negative,
      fillOpacity: "0.5",
      strokeOpacity: "0.8",
      strokeWidth: strokeWidth
    });
  })));
};